module.exports = __webpack_public_path__ + "img/popupAd-day4.dfb91970.png";